import { render } from "./ProjectsComp.vue?vue&type=template&id=b1da7d88"
import script from "./ProjectsComp.vue?vue&type=script&lang=js"
export * from "./ProjectsComp.vue?vue&type=script&lang=js"

import "./ProjectsComp.vue?vue&type=style&index=0&id=b1da7d88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__